import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'fundingInfoWarehouseBankId',
    label: 'Warehouse Bank',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'commitmentNumber',
    label: 'Commitment #',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fundingInfoWireAmount',
    label: 'Wire Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fundingConfirmationNumber',
    label: 'Funding Confirmation Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'warehouseFundingOrdered',
    label: 'Warehouse Funding Ordered',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'wirePostedDate',
    label: 'Wire Posted Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'curtailment',
    label: 'Curtailment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'wireComments',
    label: 'Wire Comments',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const fundingInformationForm = {
  name: FormNames.FUNDING_INFORMATION,
  label: 'Funding Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
